import {
  SET_SUPER_OFFERS_IMPRESSIONS_SENT,
  SET_APPLY_TO_IMPRESSIONS_SENT,
  SET_DAILY_SPECIALS_IMPRESSIONS_SENT
} from 'src/redux/actions/impressions';


const initialState = {
  superOffersImpressionSent: false,
  dailySpecialsImpressionSent: false,
  applyToImpressionSent: false
};

const dailySpecialsImpressionsReducer = (state = initialState, action) => ({
  [SET_SUPER_OFFERS_IMPRESSIONS_SENT]: () => ({
    ...state,
    superOffersImpressionSent: action.payload
  }),
  [SET_DAILY_SPECIALS_IMPRESSIONS_SENT]: () => ({
    ...state,
    dailySpecialsImpressionSent: action.payload
  }),
  [SET_APPLY_TO_IMPRESSIONS_SENT]: () => ({
    ...state,
    applyToImpressionSent: action.payload
  })
}[action.type] || (() => state))();


export default dailySpecialsImpressionsReducer;
